import { render, staticRenderFns } from "./CurrentHolds.vue?vue&type=template&id=363ca814"
import script from "./CurrentHolds.vue?vue&type=script&lang=js"
export * from "./CurrentHolds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports